import { AnswerType } from "../constants"

import { checkIsInput } from "./checkIsInput"

export function showNextButton(type: AnswerType, required: boolean): boolean {
    return (
        checkIsInput(type) ||
        type === AnswerType.choices ||
        (type === AnswerType.yes_no && !required) ||
        (type === AnswerType.choice && !required)
    )
}
